import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18FileG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M8.376 3.495a3.29 3.29 0 0 1 4.79 4.509l-.142.15-4.15 4.148a1.95 1.95 0 0 1-2.663-.095 1.95 1.95 0 0 1-.166-2.555l.11-.136 4.12-4.12a.6.6 0 0 1 .919.765l-.07.083-4.094 4.092a.755.755 0 0 0 .94 1.151l.086-.061 4.12-4.12A2.09 2.09 0 0 0 9.35 4.23l-.127.116-4.118 4.079a3.434 3.434 0 0 0 4.705 4.999l.147-.139 4.13-4.12a.6.6 0 0 1 .917.767l-.07.083-4.13 4.12a4.634 4.634 0 0 1-6.71-6.388l.165-.173z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18FileG$1 = Svg18FileG;

export { Svg18FileG$1 as default };
